import React, { Component } from 'react';
import { connect } from 'react-redux';
import GradesList from '../common/GradesList';
import { withTranslation } from 'react-i18next';
import utils from '../../common/services/utils';
import { getChild } from '../reducer';

class Neurological extends Component {
	constructor(props) {
		super(props);
		this.handleGradeSelect = this.handleGradeSelect.bind(this);
	}

	handleGradeSelect(grade) {
		this.props.history.push(`/neurological-info/${grade.slug}`);
	}

	render() {
		const { grades } = this.props;

		return (<div>
			<GradesList grades={grades} onSelect={this.handleGradeSelect} />
		</div >);
	}
}

const mapStateToProps = state => {
	const { parent, entities: { grades, childLessons }, filters } = state;

	const allGrades = Object.keys(grades).map(key => grades[key]);

	// child lessons should be already loaded for Home page
	const dashboardLessonsFilter = filters.childLessonsForDashboard.all || { ids: [] };
	const dashboardLessons = dashboardLessonsFilter.ids.map(id => childLessons[id]);

	allGrades.forEach(grade => {
		const lessonsForGrade = dashboardLessons.filter(lesson => lesson.gradeId === grade.id);
		if (lessonsForGrade.length > 0) {
			grade.attendingChildren = Object.keys(utils.groupBy(lessonsForGrade, 'childId'))
				.map(childId => getChild(parent, childId))
				.filter(child => child !== undefined);
		}
	});

	return {
		grades: allGrades
	};
};

export default connect(mapStateToProps)(withTranslation()(Neurological));